module.exports = __webpack_public_path__ + "static/img/2.e71cf68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news28/2.png
// module id = /Bxa
// module chunks = 1